import { useState } from 'react';
import './App.css';
import UnifiedChatbot from './components/chatbot/EnhancedConversationalChatbot';
import AdminShell from './components/accuracy/AdminShell';

const DEV_PASSWORD = 'poolbrainpool';

// True when this tab was opened with ?page=queries
const IS_QUERIES_TAB = new URLSearchParams(window.location.search).get('page') === 'queries';

function App() {
  // Persist auth across tabs via localStorage
  const [isDevAuthenticated, setIsDevAuthenticated] = useState(
    () => localStorage.getItem('pb_dev_auth') === 'true'
  );

  // Auto-show login if this is the queries tab and not yet authenticated
  const [showDevLogin, setShowDevLogin] = useState(
    () => IS_QUERIES_TAB && localStorage.getItem('pb_dev_auth') !== 'true'
  );
  const [devPassword, setDevPassword] = useState('');
  const [devLoginError, setDevLoginError] = useState('');

  const handleDevLogin = () => {
    if (devPassword === DEV_PASSWORD) {
      localStorage.setItem('pb_dev_auth', 'true');
      setIsDevAuthenticated(true);
      setShowDevLogin(false);
      setDevPassword('');
      setDevLoginError('');
      // If triggered from the main chatbot page, open queries in a new tab
      if (!IS_QUERIES_TAB) {
        const url = new URL(window.location.href);
        url.searchParams.set('page', 'queries');
        window.open(url.toString(), '_blank');
      }
    } else {
      setDevLoginError('Invalid password');
    }
  };

  const handleOpenQueries = () => {
    if (isDevAuthenticated) {
      const url = new URL(window.location.href);
      url.searchParams.set('page', 'queries');
      window.open(url.toString(), '_blank');
    } else {
      setShowDevLogin(true);
    }
  };

  // ── Queries tab + authenticated → render QueryHistory full-page ──
  if (IS_QUERIES_TAB && isDevAuthenticated) {
    return (
      <AdminShell
        onBack={() => {
          window.close();
          window.location.href = window.location.pathname;
        }}
      />
    );
  }

  // ── Dev login modal ──
  if (showDevLogin) {
    return (
      <div style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000
      }}>
        <div style={{
          backgroundColor: '#1e293b',
          borderRadius: '16px',
          padding: '2rem',
          maxWidth: '400px',
          width: '90%',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <h2 style={{ color: 'white', marginTop: 0, marginBottom: '1rem' }}>
            Developer Access
          </h2>
          <p style={{ color: '#94a3b8', marginBottom: '1.5rem', fontSize: '0.9rem' }}>
            Enter the developer password to access the query history.
          </p>

          <input
            type="password"
            value={devPassword}
            onChange={(e) => setDevPassword(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleDevLogin()}
            placeholder="Enter password"
            autoFocus
            style={{
              width: '100%',
              padding: '0.75rem 1rem',
              borderRadius: '8px',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              backgroundColor: 'rgba(255, 255, 255, 0.05)',
              color: 'white',
              fontSize: '1rem',
              marginBottom: '0.5rem',
              boxSizing: 'border-box'
            }}
          />

          {devLoginError && (
            <p style={{ color: '#ef4444', fontSize: '0.875rem', margin: '0.5rem 0' }}>
              {devLoginError}
            </p>
          )}

          <div style={{ display: 'flex', gap: '0.75rem', marginTop: '1.5rem' }}>
            <button
              onClick={() => {
                setShowDevLogin(false);
                setDevPassword('');
                setDevLoginError('');
                // If cancelled on the queries tab, go back to the chatbot
                if (IS_QUERIES_TAB) {
                  window.location.href = window.location.pathname;
                }
              }}
              style={{
                flex: 1,
                padding: '0.75rem',
                borderRadius: '8px',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                backgroundColor: 'transparent',
                color: '#94a3b8',
                cursor: 'pointer',
                fontSize: '0.9rem'
              }}
            >
              Cancel
            </button>
            <button
              onClick={handleDevLogin}
              style={{
                flex: 1,
                padding: '0.75rem',
                borderRadius: '8px',
                border: 'none',
                background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
                color: 'white',
                cursor: 'pointer',
                fontSize: '0.9rem',
                fontWeight: '500'
              }}
            >
              Access
            </button>
          </div>
        </div>
      </div>
    );
  }

  // ── Default: chatbot ──
  return <UnifiedChatbot onOpenQueries={handleOpenQueries} />;
}

export default App;
